import type { FollowUpSkillItemResponse, TrainingEnrollmentStatus } from '@lms/shared'

export interface SkillItemGroup {
  category: string
  items: FollowUpSkillItemResponse[]
}

/** スキルチェックシートと同じく、並び順で連続する大項目ごとにまとめる */
export function groupSkillItemsByCategory(items: FollowUpSkillItemResponse[]): SkillItemGroup[] {
  const groups: SkillItemGroup[] = []
  for (const item of [...items].sort((a, b) => a.sortOrder - b.sortOrder)) {
    const last = groups[groups.length - 1]
    if (last?.category === item.category) {
      last.items.push(item)
    } else {
      groups.push({ category: item.category, items: [item] })
    }
  }
  return groups
}

/** 受講完了時にフォローアップが作成された後の受講ステータス */
const FOLLOW_UP_SHEET_STATUSES: TrainingEnrollmentStatus[] = ['in_follow_up', 'closed']

export function hasFollowUpSheet(status: string): boolean {
  return FOLLOW_UP_SHEET_STATUSES.includes(status as TrainingEnrollmentStatus)
}
